export var RoleType;
(function (RoleType) {
    RoleType["DIMENSION"] = "DIMENSION";
    RoleType["MEASURE"] = "MEASURE";
})(RoleType || (RoleType = {}));
export var VariableType;
(function (VariableType) {
    VariableType["DISCRETE"] = "DISCRETE";
    VariableType["CONTINUOUS"] = "CONTINUOUS";
})(VariableType || (VariableType = {}));
export var FieldType;
(function (FieldType) {
    FieldType["DATA"] = "DATA";
    FieldType["MODELCALC"] = "MODELCALC";
    FieldType["MODELNAMES"] = "MODELNAMES";
    FieldType["MODELVALUES"] = "MODELVALUES";
    FieldType["VIEWCALC"] = "VIEWCALC";
    FieldType["VIEWNAMES"] = "VIEWNAMES";
    FieldType["VIEWVALUES"] = "VIEWVALUES";
    FieldType["MODELMULTIPLE"] = "MODELMULTIPLE";
})(FieldType || (FieldType = {}));
export class BField {
    static GenerateID() {
        return Math.random().toString(16).slice(2, 6);
    }
    get isNames() {
        return false;
    }
    get isValues() {
        return false;
    }
    get isMultiple() {
        return false;
    }
    get isStandard() {
        return !this.isSystem;
    }
    get isSystem() {
        return this.isValues || this.isNames || this.isMultiple;
    }
    get isDimension() {
        return this.roleType === RoleType.DIMENSION;
    }
    get isMeasure() {
        return this.roleType === RoleType.MEASURE;
    }
    get isContinuous() {
        return this.varType === VariableType.CONTINUOUS;
    }
    get isDiscrete() {
        return this.varType === VariableType.DISCRETE;
    }
}
